import { makeStyles } from '@mui/styles';
import { ThemeProvider, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import NavbarMobileLayout2 from 'app/fuse-layouts/layout2/components/NavbarMobileLayout2';
import NavbarToggleFab from 'app/fuse-layouts/shared-components/NavbarToggleFab';
import PublicNavbar from 'app/fuse-layouts/shared-components/PublicNavbar';
import { navbarCloseMobile } from 'app/store/fuse/navbarSlice';
import clsx from 'clsx';
import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectNavbarTheme } from 'app/store/fuse/settingsSlice';
import NavbarLayout2 from './NavbarLayout2';
import PropTypes from 'prop-types';

const navbarWidth = 280;

const useStyles = makeStyles(theme => ({
	navbar: {
		height: 64,
		minHeight: 64,
		maxHeight: 64
	},
	navbarMobile: {
		width: navbarWidth,
		minWidth: navbarWidth,
		transition: theme.transitions.create(['width', 'min-width'], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.shorter
		})
	}
}));

function NavbarWrapperLayout2(props) {
	const dispatch = useDispatch();
	const config = useSelector(({ fuse }) => fuse.settings.current.layout.config);
	const navbarTheme = useSelector(selectNavbarTheme);
	const navbar = useSelector(({ fuse }) => fuse.navbar);
	const userId = useSelector(({ auth }) => auth.user.data?.userId);
	const theme = useTheme();
	const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));

	const classes = useStyles(props);

	if (!userId) {
		return <PublicNavbar />;
	}

	return (
		<>
			<ThemeProvider theme={navbarTheme}>
				{isLgUp && (
					<NavbarLayout2 className={clsx(classes.navbar, props.className)} />
				)}

				{!isLgUp && (
					<SwipeableDrawer
						anchor="left"
						variant="temporary"
						open={navbar.mobileOpen}
						classes={{
							paper: clsx(classes.navbarMobile, 'flex-col flex-auto h-full')
						}}
						onClose={() => dispatch(navbarCloseMobile())}
						onOpen={() => {}}
						disableSwipeToOpen
						ModalProps={{
							keepMounted: true
						}}
					>
						<NavbarMobileLayout2 />
					</SwipeableDrawer>
				)}
			</ThemeProvider>

			{config.navbar.display && !config.toolbar.display && !isLgUp && (
				<NavbarToggleFab />
			)}
		</>
	);
}

NavbarWrapperLayout2.propTypes = {
  className: PropTypes.string,
};

export default memo(NavbarWrapperLayout2);
